import { css } from 'styled-components';
import { map } from '@lendi-ui/breakpoint';
import { deriveSize } from '@lendi-ui/utils';

var Spacing = {
  auto: 'auto',
  nil: '0',
  xxxs: deriveSize(0.25),
  xxs: deriveSize(0.5),
  xs: deriveSize(0.75),
  sm: deriveSize(1),
  md: deriveSize(1.5),
  lg: deriveSize(2),
  xl: deriveSize(2.5),
  xxl: deriveSize(4),
  xxxl: deriveSize(5)
};

function createSpacingMixin(mapValueToStyle) {
  return size => map(size, s => s === undefined ? '' : mapValueToStyle(Spacing[s]));
}

var m = createSpacingMixin(size => css(["margin:", ";"], size));
var mx = createSpacingMixin(size => css(["margin-left:", ";margin-right:", ";"], size, size));
var my = createSpacingMixin(size => css(["margin-top:", ";margin-bottom:", ";"], size, size));
var mt = createSpacingMixin(size => css(["margin-top:", ";"], size));
var mr = createSpacingMixin(size => css(["margin-right:", ";"], size));
var mb = createSpacingMixin(size => css(["margin-bottom:", ";"], size));
var ml = createSpacingMixin(size => css(["margin-left:", ";"], size));
var p = createSpacingMixin(size => css(["padding:", ";"], size));
var px = createSpacingMixin(size => css(["padding-left:", ";padding-right:", ";"], size, size));
var py = createSpacingMixin(size => css(["padding-top:", ";padding-bottom:", ";"], size, size));
var pt = createSpacingMixin(size => css(["padding-top:", ";"], size));
var pr = createSpacingMixin(size => css(["padding-right:", ";"], size));
var pb = createSpacingMixin(size => css(["padding-bottom:", ";"], size));
var pl = createSpacingMixin(size => css(["padding-left:", ";"], size));
var margin = css(["", " ", " ", " ", " ", " ", " ", ""], props => props.m && m(props.m), props => props.mx && mx(props.mx), props => props.my && my(props.my), props => props.mt && mt(props.mt), props => props.mr && mr(props.mr), props => props.mb && mb(props.mb), props => props.ml && ml(props.ml));

export { Spacing, m, margin, mb, ml, mr, mt, mx, my, p, pb, pl, pr, pt, px, py };
